import { Injectable } from '@angular/core';
import { gql, Query } from 'apollo-angular';

@Injectable({
  providedIn: 'any',
})
export class QueryMobilityGeoContratGQLService extends Query<Response> {
  document = gql`
    query Referentiel_mobilite_geographique {
      referentiel_mobilite_geographique {
        codeTypeTerritoire
        libelleTypeTerritoire
      }
    }
  `;
}
